import Swiper from 'swiper'

// Get every album on the page
const albums = document.querySelectorAll('.bloc-album:not(.bloc-album--pinterest)');

for (let i = 0; i < albums.length; i++) {
    let itemClass = `item-${i}`;
    // Add class for each items
    albums[i].classList.add(itemClass);

    // Get every data-attribute to build config
    let dataAutoScroll = albums[i].querySelector('.swiper-container').getAttribute('data-auto_scroll');
    let dataAutoScrollSpeed = albums[i].querySelector('.swiper-container').getAttribute('data-auto_scroll_speed');
    dataAutoScrollSpeed = dataAutoScrollSpeed + '000';
    let dataMargins = albums[i].querySelector('.swiper-container').getAttribute('data-margins');

    // Declare basic & common config (every sliders got this)
    let config = {
        grabCursor : 'true',

        fadeEffect: {
            crossFade: true
        },

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        navigation: {
            nextEl: `.bloc-album.${itemClass} .swiper-button-next`,
            prevEl: `.bloc-album.${itemClass} .swiper-button-prev`,
        },
    }

    // Basic config of gallery sliders (2 sliders for gallery)
    let configGallery = {
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    }

    // Specific config between different sliders
    if(albums[i].classList.contains('bloc-album--basic')){
        console.log('basic');
        config.effect = 'slide';
        config.lazy= true;
        config.loop = true;
        if(dataAutoScroll === 'true'){
            config.autoplay = {
                delay: dataAutoScrollSpeed,
                disableOnInteraction: false,
            }
        }
    }
    else if(albums[i].classList.contains('bloc-album--multiple_slides')){
        console.log('multiple_slides');
        config.effect = 'slide';
        config.lazy= true;
        config.loop = true;
        if(dataAutoScroll === 'true'){
            config.autoplay = {
                delay: dataAutoScrollSpeed,
                disableOnInteraction: false,
            }
        }
        if(window.innerWidth < 620){
            config.slidesPerView= 1;
        }
        else if(window.innerWidth < 960){
            config.slidesPerView= 2;
        }
        else{
            config.slidesPerView= 3;
        }
        config.spaceBetween= 0;
        if(dataMargins === 'true'){
            if(window.innerWidth < 960){
                config.spaceBetween= 20;
            }
            else{
                config.spaceBetween= 30;
            }
        }
    }
    else if(albums[i].classList.contains('bloc-album--multiple_rows')){
        console.log('multiple_rows');
        config.effect = 'slide';
        config.slidesPerView= 2;
        config.slidesPerColumn= 2;
        config.slidesPerGroup= 2;
        config.spaceBetween= 0;
        if(window.innerWidth < 620){
            config.slidesPerView= 1;
            config.slidesPerGroup= 1;
        }

        if(dataMargins === 'true'){
            if(window.innerWidth < 960){
                config.spaceBetween= 20;
            }
            else{
                config.spaceBetween= 30;
            }
        }
    }
    else if(albums[i].classList.contains('bloc-album--coverflow')){
        console.log('coverflow');
        config.effect = 'coverflow';
        config.centeredSlides= true;
        config.slidesPerView= 'auto';
        config.loop = true;
        let coverflowstretch = -30;
        if(window.innerWidth < 620){
            coverflowstretch = -10;
        }
        config.coverflowEffect = {
            rotate: 40,
                stretch: coverflowstretch,
                depth: 150,
                modifier: 1,
                slideShadows: true,
        }
        if(dataAutoScroll === 'true'){
            config.autoplay = {
                delay: dataAutoScrollSpeed,
                disableOnInteraction: false,
            }
        }
    }
    else if(albums[i].classList.contains('bloc-album--flip')){
        console.log('flip');
        config.effect = 'flip';
        config.loop = true;
        config.flipEffect = {
            slideShadows: false,
            limitRotation : true,
        }
        if(dataAutoScroll === 'true'){
            config.autoplay = {
                delay: dataAutoScrollSpeed,
                disableOnInteraction: false,
            }
        }
    }
    else if(albums[i].classList.contains('bloc-album--gallery')){
        console.log('gallery');
        config.effect = 'fade';
        config.lazy = true;
        config.loop = true;
        config.flipEffect = {
            slideShadows: false,
            limitRotation : true,
        }
        if(dataMargins === 'true'){
            configGallery.spaceBetween= 10;
        }
        if(dataAutoScroll === 'true'){
            config.autoplay = {
                delay: dataAutoScrollSpeed,
                disableOnInteraction: false,
            }
        }
    }

    // Call swiper for gallery (bottom slider)
    if(albums[i].classList.contains('bloc-album--gallery')){
        let swiperGallery = new Swiper(`.bloc-album.${itemClass} .gallery-thumbs`, configGallery);
        config.thumbs = {
            swiper: swiperGallery
        }
    }

    // Call swiper for every sliders with custom config
    let swiperBasic = new Swiper(`.bloc-album.${itemClass} .swiper-container:not(.gallery-thumbs)`, config);
}

